module.exports = __webpack_public_path__ + "33eeac8e430855e04487d1c966278559.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/13_C3.mp3
// module id = 112
// module chunks = 0